import React from "react";
import Model from "./model";

import "./Landing.css";

function Landing() {
  return <Model />;
}

export default Landing;
